import { useEffect, useRef } from "react";
import dayjs from "dayjs";

function getEndOfDay() {
  return dayjs().endOf("day").toISOString();
}

function safeParseDate(date) {
  if (!date) return null;

  const parsed = dayjs(date);

  return parsed.isValid() ? parsed.toDate() : null;
}

function safeFormatDate(date) {
  if (!date) return null;

  const parsed = dayjs(date);

  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
}

export function getStoredPeriod(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);

    if (!raw) {
      return {
        data: null,
        expired: false,
      };
    }

    const data = JSON.parse(raw);

    if (!data?.expiresAt) {
      localStorage.removeItem(storageKey);

      return {
        data: null,
        expired: true,
      };
    }

    const expiresAt = dayjs(data.expiresAt);

    if (!expiresAt.isValid()) {
      localStorage.removeItem(storageKey);

      return {
        data: null,
        expired: true,
      };
    }

    if (dayjs().isAfter(expiresAt)) {
      localStorage.removeItem(storageKey);

      return {
        data: null,
        expired: true,
      };
    }

    return {
      data: {
        start: safeParseDate(data.start),
        end: safeParseDate(data.end),
        timeFilter: data.timeFilter ?? null,
      },
      expired: false,
    };
  } catch {
    localStorage.removeItem(storageKey);

    return {
      data: null,
      expired: true,
    };
  }
}

export function useCalendarPeriodStorage({
  storageKey,
  startDate,
  endDate,
  // setStartDate,
  // setEndDate,
  timeFilter,
  // setTimeFilter,
  debounceMs = 300,
}) {
  if (!storageKey) {
    throw new Error("useCalendarPeriodStorage: storageKey is required");
  }

  const timeoutRef = useRef(null);
  const isInitializedRef = useRef(true);

  // // INIT FROM STORAGE
  // useEffect(() => {
  //   if (isInitializedRef.current) return;

  //   const { data } = getStoredPeriod(storageKey);

  //   if (data) {
  //     setStartDate(data.start);
  //     setEndDate(data.end);

  //     if (setTimeFilter) {
  //       setTimeFilter(data.timeFilter);
  //     }
  //   }

  //   isInitializedRef.current = true;
  // }, [storageKey, setStartDate, setEndDate, setTimeFilter]);

  // SAVE TO STORAGE
  useEffect(() => {
    if (!isInitializedRef.current) return;

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // nothing to save
    if (!startDate && !endDate && !timeFilter) {
      localStorage.removeItem(storageKey);
      return;
    }

    timeoutRef.current = setTimeout(() => {
      const payload = {
        start: safeFormatDate(startDate),
        end: safeFormatDate(endDate),
        timeFilter: timeFilter ?? null,
        expiresAt: getEndOfDay(),
      };

      localStorage.setItem(storageKey, JSON.stringify(payload));
    }, debounceMs);

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [storageKey, startDate, endDate, timeFilter, debounceMs]);
}
